import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlanning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlanning"><Path fillRule="evenodd" clipRule="evenodd" d="M9.79908 5.09352L5.52822 10.8592L2.6908 8.30552L3.69424 7.19058L5.3051 8.64035L8.59374 4.20068L9.79908 5.09352ZM11 6.99977H21V8.49977H11V6.99977ZM2.99999 16.2498C2.99999 14.731 4.23121 13.4998 5.74999 13.4998C7.26877 13.4998 8.49999 14.731 8.49999 16.2498C8.49999 17.7686 7.26877 18.9998 5.74999 18.9998C4.23121 18.9998 2.99999 17.7686 2.99999 16.2498ZM11 15.4998H21V16.9998H11V15.4998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlanning;
